// Assets estáticos de campaña en /public/campaign-media.
// `?v=` fuerza nueva cache key en Cloudflare/origen al cambiar assets.

export const CAMPAIGN_MEDIA_VERSION = "20260814"

export function campaignMediaUrl(path) {
  const clean = path.startsWith("/") ? path : `/campaign-media/${path}`
  const base = clean.startsWith("/campaign-media/")
    ? clean
    : `/campaign-media/${clean.replace(/^\//, "")}`
  return `${base}?v=${CAMPAIGN_MEDIA_VERSION}`
}

/** Logo CBQ: display ~40–70px; archivo 160px (+WebP). */
export const LOGO_CBQ = {
  webp: campaignMediaUrl("/campaign-media/logo-cbq-gris-160.webp"),
  png: campaignMediaUrl("/campaign-media/logo-cbq-gris-160.png"),
  width: 160,
  height: 159,
}

/** Wordmark hero: srcset 640/960 WebP; PNG fallback 640 (sin originales gigantes). */
export function wordmarkSources(theme) {
  const light = theme === "night"
  const stem = light ? "wordmark-light" : "wordmark-dark"
  return {
    webpSrcSet: [
      `${campaignMediaUrl(`/campaign-media/${stem}-640.webp`)} 640w`,
      `${campaignMediaUrl(`/campaign-media/${stem}-960.webp`)} 960w`,
    ].join(", "),
    png: campaignMediaUrl(`/campaign-media/${stem}-640.png`),
    sizes: "(max-width: 720px) 92vw, 640px",
    width: 640,
    height: 300,
  }
}
